import useGlobalState from './useGlobalState';

export default useGlobalState;
